import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, inject, Injectable } from '@angular/core';
import { globalStore, translate } from '../../../../modules/shared/shared.global-service';
import { selectIsFolderTerminated } from '../../../../modules/content/store/person/person.selectors';
import { localDate } from '../../../../modules/shared/pipes/local-date.pipe';
import { SessionService } from '../../../../services/session.service';
import { FolderIndividualPlanObject } from '@libs/types/src/services/object-type/folder/folder-individual-plan.object';
import { FolderGlobalStore } from '../../../../store/medicalService/folder.global-store';

@Injectable()
export class IndividualPlanStore extends ComponentStoreV2Factory {

    protected readonly session = inject(SessionService);
    protected readonly folderStore = inject(FolderGlobalStore);

    public isTerminated = globalStore!.selectSignal(selectIsFolderTerminated);

    public readonly folderId = this.folderStore.folderId;

    public history = computed<FolderIndividualPlanObject[]>(() => {
        const items = this.data.getIndividualPlans()?.items || [];

        return items.map((item: FolderIndividualPlanObject, index: number) => {
            return {
                ...item,
                index,
                createdAt: localDate(item.date, this.session),
                data: [
                    item.situation,
                    item.process,
                    item.evaluation,
                    translate.instant('individualPlan.fields.targets'),
                    ...(item.targets || []).map((it) => it.name),
                    translate.instant('individualPlan.fields.tags'),
                    ...(item.tags || []),
                ]
                    .join('<br />'),
                searchExt: `
                    ${(item.targets || []).map((it) => it.name).join(' ')}
                    ${(item.tags || []).join(' ')}
                `,
            };
        });
    });

}
